// Constants
/* 
  These values are meant to coincide with _constants.liquid
*/

// Product types
export const BOOKS = 'Books'
export const SETS = 'Book Sets'
export const CDS = 'CDs'
export const DIGITAL_DOWNLOADS = 'Digital Downloads'
export const MERCHANDISE = 'Merchandise'

// Tag prefixes
export const LEVEL_TAG_PREFIX = 'Level:'
export const INSTRUMENT_TAG_PREFIX = 'Instrument:'

// Variant options
export const INSTALMENT_VARIANT_OPTION = 'Payment'
export const INSTALMENT_VARIANT_VALUE = 'Instalment'

// Media queries
export const PALM = '(max-width: 480px)'
export const BELOW_TABLET = '(max-width: 767px)'
export const TABLET_PORTRAIT = '(max-width: 768px)'
export const MID_TABLET = '(max-width: 896px)'
export const TABLET_LANDSCAPE = '(max-width: 1024px)'
